import { FC } from 'react'
import MaskedInput from 'react-text-mask'
import { TextField } from '../../..'
import { CustomMaskedInputProps, TextMaskCustomProps } from './types'

const TextMaskCustom: FC<TextMaskCustomProps> = (props) => {
  const { mask, inputRef, ...other } = props

  return (
    <MaskedInput
      {...other}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null)
      }}
      mask={mask}
      placeholderChar={'\u2000'}
      showMask={false}
    />
  )
}

const CustomMaskedInput: FC<CustomMaskedInputProps> = (props) => {
  const { mask, ...rest } = props

  return (
    <TextField
      InputProps={{
        inputProps: { mask },
        inputComponent: TextMaskCustom as any
      }}
      {...(rest as any)}
    />
  )
}

export default CustomMaskedInput
